import React from 'react';
import cx from 'classnames';
import {LayoutContext} from '../ProductPageApp/ProductPageApp';
import s from './ProductName.scss';
import {ProvidedGlobalProps, withGlobalProps} from '../../providers/globalPropsProvider';

export interface ProductNameProps extends ProvidedGlobalProps {
  name: string;
}

class ProductNameComp extends React.Component<ProductNameProps> {
  public render(): JSX.Element {
    const {experiments} = this.props.globals;
    /* istanbul ignore next: cant test with jsdom, should be tested by sled */
    const productNameTextColor = experiments.productPriceNameFixTextColor
      ? s.productNameTextColor
      : s.oldProductNameTextColor;
    return (
      <LayoutContext.Consumer>
        {(layoutName) => (
          <h1
            data-hook="product-title"
            className={cx(s.productName, s[`productName__${layoutName}`], productNameTextColor)}>
            {this.props.name}
          </h1>
        )}
      </LayoutContext.Consumer>
    );
  }
}

export const ProductName = withGlobalProps(ProductNameComp);
